export default __webpack_public_path__ + "static/media/collectible-final-legendary.68780642.jpg";